<div class="d-flex justify-content-between align-items-center mb-2">
    <h3 class="mb-0">Option Groups</h3>
    <button mat-flat-button color="primary" (click)="openDialog()">Create Option Group</button>
</div>

<p class="text-muted small">
    Reusable sets of options (e.g. severities, door leaf materials) that select/radio/checkbox
    fields in the form builder can be populated from. Editing a group here updates it everywhere
    it's used.
</p>

<table mat-table [dataSource]="optionGroups" class="w-100">
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let group">{{ group.name }}</td>
    </ng-container>

    <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef>Options</th>
        <td mat-cell *matCellDef="let group">{{ optionsPreview(group) }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell class="hide-on-mobile" *matHeaderCellDef>Type</th>
        <td mat-cell class="hide-on-mobile" *matCellDef="let group">
            <span class="badge rounded-pill" [class.bg-secondary]="isSystem(group)" [class.bg-primary]="!isSystem(group)">
                {{ isSystem(group) ? 'System' : 'Custom' }}
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let group">
            <button mat-button (click)="openDialog(group)">{{ isSystem(group) ? 'Edit Settings' : 'Edit' }}</button>
            @if (!isSystem(group)) {
                <button mat-button color="warn" (click)="confirmDelete(group)">Delete</button>
            }
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center;" colspan="4">
            {{ isLoading ? 'Loading...' : 'No option groups found.' }}
        </td>
    </tr>
</table>
